module.exports = __webpack_public_path__ + "static/img/case_banner_12_h5.6033f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_12_h5.png
// module id = 5XeZ
// module chunks = 34